@if (isLoading()) {
  <div class="custom-links-block">
    <div class="slider-container skeleton-container">
      @for (item of skeletonItems(); track $index) {
        <div class="link skeleton-item" [class.vertical]="isVertical()">
          <ngx-skeleton-loader
            [theme]="{
              'border-radius': '4px',
              height: skeletonHeight(),
              width: skeletonWidth(),
            }"
          />
        </div>
      }
    </div>
  </div>
} @else if (links().length) {
  <div class="custom-links-block">
    <div
      class="slider-container"
      #sliderContainer
      (scroll)="onScroll()"
      [class.dragging]="isDragActive()"
      dataTest="links-slider-container"
    >
      @for (item of links(); track item) {
        <a
          [href]="item.link"
          [style]="item.icon_link | linkBackground"
          class="link"
          [class.vertical]="isVertical()"
          [target]="isVertical() ? '_self' : '_blank'"
          rel="nofollow"
          dataTest="community-link"
        >
          <span class="link-name">
            <span class="icon icon-link-external"></span>
            <span class="title">{{ item.title }}</span>
          </span>
        </a>
      }
    </div>
    @if (canScroll) {
      <div class="slider-controls">
        @if (showPrev) {
          <button class="control prev" (click)="onPrevClick()" dataTest="links-slider-control-prev">
            <span class="icon"></span>
          </button>
        }
        @if (showNext) {
          <button class="control next" (click)="onNextClick()" dataTest="links-slider-control-next">
            <span class="icon"></span>
          </button>
        }
      </div>
    }
  </div>
}
